import { useApiClient } from 'bff/ApiClientProvider';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ResponseError } from 'bff/client';

export const useGetCaseTrackingList = (options?: UseMutationOptions<Blob, ResponseError>) => {
  const { reportingApi } = useApiClient();
  const mutationOptions: typeof options = {
    ...options,
    mutationKey: ['getCaseListDownload'],
    mutationFn: async () => {
      const timeout = 15000;

      return await Promise.race([
        reportingApi.reportingGetCaseListDownload(),
        new Promise<Blob>((_, reject) =>
          setTimeout(() => reject(new Error('Timeout after 15 secs')), timeout)
        )
      ]);
    }
  };
  return useMutation(mutationOptions);
};
